import {
  CopilotActions,
  CopilotName,
  CopilotMessages,
  CopilotInput,
  Tour,
  CopilotSupportButton,
} from '@/features/copilot';
import { close, useSidebarActive } from '@/features/sidebar';
import { Box, Divider } from '@customerio/pluma-components/react';
import * as styles from './index.css';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export default function Assistant() {
  const isCopilotSidebarActive = useSidebarActive('copilot');

  useEffect(() => {
    if (isCopilotSidebarActive) {
      close();
    }
    // Only run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>Assistant | Customer.io</title>
      </Helmet>
      <Box display="flex" flexDirection="column" h="full" w="full" backgroundColor="base">
        <Box display="flex" alignItems="center" justifyContent="space-between" p="100" pl="200">
          <Box display="flex" alignItems="center" gap="100">
            <CopilotActions />
            <CopilotName />
          </Box>
          <Box display="flex" alignItems="center" gap="100">
            <CopilotSupportButton />
          </Box>
        </Box>
        <Divider />
        <Box display="flex" flexDirection="column" flexGrow="1" h="0" w="full" className={styles.contentContainer}>
          <Tour />
          <CopilotMessages />
          <CopilotInput />
        </Box>
      </Box>
    </>
  );
}
